<template>
  <div class="rounded-lg bg-white px-5 py-5 shadow-sm hidden md:block">
    <div class="flex items-center">
      <div class="flex flex-col w-full">
        <h5 class="text-brand-black text-2xl mb-2 px-1">Documents</h5>
        <div class="flex justify-between w-full mb-5">
          <div class="flex flex-row">
            <router-link
              :to="{
                name: 'dashboard_documents_templates'
              }"
            >
              <StyledTab :active="$route.name === 'dashboard_documents_templates'">
                Documents
              </StyledTab>
            </router-link>

            <router-link
              :to="{
                name: 'dashboard_documents_sent'
              }"
            >
              <StyledTab :active="$route.name === 'dashboard_documents_sent'"> Sent </StyledTab>
            </router-link>
          </div>
          <router-link :to="{ name: 'dashboard_new_document_name' }" class="flex items-center pr-5">
            <SecondaryButton>
              <div class="flex items-center">
                <PlusIcon class="text-brand-green w-5 h-5 mr-1" />
                <p class="">Upload New</p>
              </div>
            </SecondaryButton>
          </router-link>
        </div>
      </div>
    </div>

    <div class="border-b-2 w-full mt-2" style="border-color: #d7def2"></div>

    <!-- START DESKTOP ROW HEADER-->
    <div class="flex flex-row w-full pt-7 pb-3">
      <div :class="[$route.name === 'dashboard_documents_templates' ? 'w-1/5' : 'w-1/4']">
        <div class="flex flex-col justify-center h-full w-full pr-2">
          <div class="flex flex-row">
            <div class="flex items-center">
              <h5 class="text-lg font-normal">Document Name</h5>
            </div>
          </div>
          <!-- <p class="italic text-brand-gray text-sm">Document description</p> -->
        </div>
      </div>

      <template v-if="$route.name === 'dashboard_documents_templates'">
        <div class="w-1/5 flex items-center">
          <h5 class="text-lg">Included files</h5>
        </div>
        <div class="w-1/5 flex items-center">
          <h5 class="text-lg">Linked Form</h5>
        </div>
        <div class="w-1/10 px-1 flex items-center">
          <h5 class="text-lg px-1">Require <br />signature</h5>
        </div>

        <div class="w-1/10 px-1 flex items-center">
          <h5 class="text-lg pl-2">Actions</h5>
        </div>
      </template>
      <template v-else>
        <div class="w-1/4 flex items-center">
          <h5 class="text-lg">Sent to</h5>
        </div>

        <div class="w-1/4 flex items-center">
          <h5 class="text-lg">Status</h5>
        </div>

        <div class="w-1/4 flex items-center">
          <h5 class="text-lg">Last Activity</h5>
        </div>
      </template>
    </div>
    <!-- END DESKTOP ROW HEADER-->
  </div>

  <router-view :key="$route.fullPath" />
</template>
<script>
import { PlusIcon } from "@heroicons/vue/outline"

import { mapGetters } from "vuex"
import btoa from "btoa"

import { APPLICATION_TEMPLATE_GET_LIST, APPLICATION_TEMPLATE_SORT_LIST } from "@/store/types"

export default {
  components: {
    PlusIcon
  },
  computed: {
    ...mapGetters([
      "getApplicationTemplates",
      "isApplicationTemplateLoading",
      "getApplicationTemplatesCurrentPage",
      "getApplicationTemplatesTotalCount",
      "getCurrentUser"
    ]),
    origin() {
      return location.origin
    },
    hostname() {
      return location.hostname
    }
  },
  async mounted() {
    if (this.$route.name === "dashboard_documents") {
      this.$router.push({ name: "dashboard_documents_templates" })
    }
  },
  data() {
    return {
      nameSortDirection: "",
      priceSortDirection: "",
      showMobileModal: false,
      selectedForm: null,
      showShareModal: false,
      showWelcomeModalInternal: false,
      tooltip: {},
      showQRModal: false
    }
  },
  methods: {
    sortBy(type) {
      if (type === "price") {
        if (this.priceSortDirection === "") {
          this.priceSortDirection = "asc"
        } else if (this.priceSortDirection === "asc") {
          this.priceSortDirection = "desc"
        } else {
          this.priceSortDirection = "asc"
        }
      } else {
        if (this.nameSortDirection === "") {
          this.nameSortDirection = "asc"
        } else if (this.nameSortDirection === "asc") {
          this.nameSortDirection = "desc"
        } else {
          this.nameSortDirection = "asc"
        }
      }

      const direction = type === "price" ? this.priceSortDirection : this.nameSortDirection

      this.$store.commit(APPLICATION_TEMPLATE_SORT_LIST, { type, direction })
    },
    async loadApptemplates(page) {
      await this.$store.dispatch(APPLICATION_TEMPLATE_GET_LIST, { page })
    },
    openWelcomeModal() {
      this.showWelcomeModalInternal = true
    },
    closeWelcomeModal() {
      this.showWelcomeModalInternal = false
    },
    openMobileModal(apptemp) {
      this.showMobileModal = true
      this.selectedForm = apptemp
    },
    closeMobileModal(resetSelected = true) {
      this.showMobileModal = false

      if (resetSelected) this.selectedForm = null
    },
    openShareModal(apptemp) {
      this.showShareModal = true
      if (apptemp) this.selectedForm = apptemp

      if (this.showMobileModal) {
        this.showMobileModal = false
      }
    },
    closeShareModal() {
      this.showShareModal = false
    },
    getEncodedUsername(username) {
      return btoa(username)
    },
    openQRModal(apptemp) {
      this.showQRModal = true

      if (apptemp) this.selectedForm = apptemp
    },
    closeQRModal() {
      this.showQRModal = false
    }
  }
}
</script>
